import {ArtfactKind, EnvironmentKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of} from 'rxjs';
import {concatMap, map} from 'rxjs/operators';
import {HttpHook} from '../http/http.hook';
import moment from 'moment';

@HookClass('workflow')
export class WorkflowHook extends BaseHook {

    @Hook('cb8f58b3-d47e-4e1d-b76f-05fdc378040a')
    public getTaskByStep(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://workflow.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://workflow.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/8130ea1f-85ac-4525-b232-7bd42c8b2305`,
                                params: {},
                                headers: {
                                    'nick-system': '6e6ed079-7dab-4b7b-b1ad-05043f714596',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('cac28743-8564-457c-9b1d-10413f734e64')
    public createSubTask(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://workflow.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://workflow.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/65cea449-fa10-4f4c-8225-196cefabbba1`,
                                params: {},
                                headers: {
                                    'nick-system': '6e6ed079-7dab-4b7b-b1ad-05043f714596',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('a60cf813-a773-4d1b-96c5-70afebb68d16')
    public updateTask(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://workflow.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://workflow.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/628e2a06-1de6-4cab-baeb-861642456b0e`,
                                params: {},
                                headers: {
                                    'nick-system': '6e6ed079-7dab-4b7b-b1ad-05043f714596',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('d66c11d2-fc17-4475-8914-dde5396fdbb5')
    public completeTasks(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://workflow.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://workflow.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/a1299c37-d7d2-4ca9-ac76-79f712eb8db0`,
                                params: {},
                                headers: {
                                    'nick-system': '6e6ed079-7dab-4b7b-b1ad-05043f714596',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('222278bd-ec85-43b6-8cee-0c58248d8e1f')
    public moveTask(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://workflow.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://workflow.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/60b2892d-f9dc-4e4c-9da4-0b4ad0fc0dfc`,
                                params: {},
                                headers: {
                                    'nick-system': '6e6ed079-7dab-4b7b-b1ad-05043f714596',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('2a15e9b6-9fdb-46c5-b098-70967829c071')
    public prepareRunWorkflow(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://workflow.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://workflow.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/8716b115-6113-42dd-8304-290a82922285`,
                                params: {},
                                headers: {
                                    'nick-system': '6e6ed079-7dab-4b7b-b1ad-05043f714596',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('7d8315f5-6fdd-4b25-b4df-8dfd7b0f276e')
    public getTaskByParentTaskId(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://workflow.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://workflow.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/8163e5a8-3128-48f9-ab3b-f7cb88b8cf59`,
                                params: {},
                                headers: {
                                    'nick-system': '6e6ed079-7dab-4b7b-b1ad-05043f714596',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('824164df-5f09-417d-a7e9-b07010604ca6')
    public createAttachment(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://workflow.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://workflow.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/27820908-2a82-4839-b4d3-f039e32705fa`,
                                params: {},
                                headers: {
                                    'nick-system': '6e6ed079-7dab-4b7b-b1ad-05043f714596',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('66e7d01a-deae-4eee-8750-c37dd6089f9a')
    public getTasksByParentExecutionId(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://workflow.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://workflow.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/74d5835b-2ffa-460d-91b7-74fc457bf470`,
                                params: {},
                                headers: {
                                    'nick-system': '6e6ed079-7dab-4b7b-b1ad-05043f714596',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('34ee06a4-a5d2-4690-b40b-0bf587ec715f')
    public createUpdateExecutionTags(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://workflow.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://workflow.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/edd1d7a7-bd44-48e9-ae48-de1beb07811d`,
                                params: {},
                                headers: {
                                    'nick-system': '6e6ed079-7dab-4b7b-b1ad-05043f714596',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('8292d81f-4291-45d5-9839-58872fe48c9b')
    public downloadAttachment(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://workflow.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://workflow.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/803e7dc7-fc18-4aac-b2ce-9b45b8a0b3c5`,
                                params: {},
                                headers: {
                                    'nick-system': '6e6ed079-7dab-4b7b-b1ad-05043f714596',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('813c9271-a75e-4876-b244-815fc43f74c5')
    public getReferenceWorkflow(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://workflow.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://workflow.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/1a2f1065-a60d-4c5f-a7fc-0e443362865e`,
                                params: {},
                                headers: {
                                    'nick-system': '6e6ed079-7dab-4b7b-b1ad-05043f714596',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

}

